(function () {
  function setup(section) {
    var track = section.querySelector('.vp-cat-carousel__track');
    var prevBtn = section.querySelector('.vp-cat-carousel__arrow--prev');
    var nextBtn = section.querySelector('.vp-cat-carousel__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollAmount() {
      var card = track.querySelector('.vp-cat-card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function init() {
    document.querySelectorAll('.vp-cat-carousel').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
